// Widget Scripts
import cardWidget from './js/widgets/cardWidget.js';
import infoGraphic from './js/widgets/infographic.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardwidgetFeature from './js/widgets/cardwidgetFeature.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import hotButtons from './js/widgets/hotButtons.js';
import cssSponsors from './js/widgets/cssSponsors.js';
import microModal from './js/widgets/microModal';
import footerWidget from './js/widgets/footerWidget.js';
import footerWidgetSubpage from './js/widgets/footerWidgetSubpage.js';
// Custom Theme Scripts
import './js/localjs.js';
import './js/SiteInfoBanner.js';
//import './js/popup.js';
// Aos Library
import AOS from 'aos';
import 'aos/dist/aos.css';

 if (window.location.pathname === '/') {
   
  $(document).ready(function() {
    cardWidget();  
    infoGraphic(); 
    swiperWidget();
    seoWidget();
    hotButtons();
    multiScheduleFeature();
    cssSponsors();
    cardwidgetFeature();
    microModal(); 
  });
}
$(document).ready(function() {
  footerWidget();
  footerWidgetSubpage();
AOS.init({
    offset: 100, // Change this value as needed
    duration: 800, // Animation duration in milliseconds
    easing: 'ease', // Easing function
    // Add more options as needed
  });
   // Initialize AOS
   AOS.init();

   // Lazy load images
   $('.lazy-load').each(function() {
     var img = $(this);
     img.attr('src', img.data('src')).on('load', function() {
       img.removeAttr('data-src');
     });
});
});